import { ArrowRight, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trackEvent } from "@/lib/analytics";
import { h2Lg, textLink } from "./styles";

const ITEMS = ["free", "markets", "ai", "broker"] as const;

/** Native <details>/<summary>: keyboard + screen-reader friendly, readable without JS. */
const HomeFAQ = () => {
  const { t } = useTranslation();
  return (
    <section id="faq" aria-labelledby="faq-h" className="scroll-mt-[72px] px-[22px] py-[clamp(88px,9vw,128px)]">
      <div className="mx-auto max-w-[820px]">
        <h2 id="faq-h" className={`pf-rv text-center ${h2Lg}`}>
          {t("home.faq.title")}
        </h2>
        <div className="pf-rv2 mt-12 border-t border-foreground/15">
          {ITEMS.map((key) => (
            <details
              key={key}
              className="group border-b border-foreground/15"
              onToggle={(e) => {
                if ((e.currentTarget as HTMLDetailsElement).open) {
                  trackEvent("faq_open", { question: key, location: "home" });
                }
              }}
            >
              <summary className="flex min-h-[72px] cursor-pointer list-none items-center justify-between gap-4 py-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-primary [&::-webkit-details-marker]:hidden">
                <span className="text-xl font-semibold tracking-[-0.015em]">{t(`home.faq.items.${key}.q`)}</span>
                <Plus aria-hidden="true" className="pf-pm h-5 w-5 flex-none group-open:rotate-45" strokeWidth={1.8} />
              </summary>
              <p className="m-0 pb-6 pe-10 text-[17px] leading-[1.55] text-pf-ink2">{t(`home.faq.items.${key}.a`)}</p>
            </details>
          ))}
        </div>
        <p className="mt-8 text-center text-[17px]">
          <Link to="/faq" className={textLink}>
            {t("home.faq.all")}
            <ArrowRight aria-hidden="true" className="h-4 w-4 rtl:-scale-x-100" />
          </Link>
        </p>
      </div>
    </section>
  );
};

export default HomeFAQ;
